export default "__VITE_ASSET__CmIQ0ku8__"